import { v4 as uuidv4 } from 'uuid';
import { QuoteType } from './quote-data';
export class QuoteSessionOptions {
  uuid: string;
  quoteType: QuoteType;
  quoteId: number;
  revisionId: number;
  optionId: number;
  username: string;
  optionUuid: string;

  constructor(
    quoteType: QuoteType,
    quoteId: number,
    revisionId: number,
    optionId: number,
    username: string,
    optionUuid: string
  ) {
    this.uuid = uuidv4();
    this.quoteType = quoteType;
    this.quoteId = quoteId;
    this.revisionId = revisionId;
    this.optionId = optionId;
    this.username = username;
    this.optionUuid = optionUuid;
  }
}
